export default __webpack_public_path__ + "static/media/x.933b3705.svg";